// extracted by mini-css-extract-plugin
export default {"root":"IconArchive_root__1OSVY"};